<template>
    <div class="agency-content">
        <div class="agency-text">
            {{lbl.detail.distributed_by}}
        </div>
        <div class="agency-logo">
            <img :src="getAgencyLogoUrl()" />
        </div>
        <div class="agency-text">
            {{campaign.agencyName}}
        </div>
    </div>
</template>

<script>

export default {
    name: 'DetailAgency',
    props: {
        lbl: Object,
        campaign: Object
    },
    methods: {
        getAgencyLogoUrl: function () {
            return this.campaign.agencyLogoUrl;
        },
    }
}
</script>

<style lang="scss" scoped>
@import "@/style/base/base.scss";

.agency-content {
    display: grid;
    gap: 16px;
    padding: 16px;
    border-radius: 8px;
    background-color: #f6f6f6;

    .agency-text {
        font-size: $px14;
        color: $a-gray-999999;
    }

    .agency-logo {
        width: 100%;
        img {
            height: 50px;
            width: auto;
        }
    }
}
</style>
